import api from "../api";
import {commit} from "lodash/seq";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        vendor_category: {},
        vendor_categories: {data: [], current_page: 1, total: 0, per_page: 10},
        loading: false,
        errors: {
            data: {
                errors: {
                    name: [],
                    is_metred: [],
                }
            }
        },
        has_errors: false,
    },
    getters: {
        loading: state => state.loading,
        vendor_category: state => state.vendor_category,
        dialogVisible: state => state.dialogVisible,
        vendor_categories: state => state.vendor_categories,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setVendorCategories(state, data) {
            state.vendor_categories = data;
        },
        setVendorCategory(state, data) {
            state.vendor_category = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            name: [],
                        }
                    }
                };
            }
        }
    },
    actions: {
        async openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async getVendorCategories({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'vendor_category/list', {root: true});
                const response = await api.getVendorCategories(filters);
                commit('setVendorCategories', response);
                commit('setLoading', false)
                commit('deactivateLoading', 'vendor_category/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },
        async getVendorCategory({commit}, id) {
            try {
                commit('activateLoading', 'vendor_category/list', {root: true});
                const response = await api.getVendorCategory(id);
                commit('setVendorCategory', response?.data);
                commit('deactivateLoading', 'vendor_category/list', {root: true});
            } catch (e) {
                ElMessage.error("Something went wrong, please try again later.");
            }
        },
        async createVendorCategory({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                const response = await api.createVendorCategory(data);
                commit('setVendorCategory', response?.data);
                dispatch('getVendorCategories', {
                    paginate: true
                })
                ElMessage.success('Vendor category created successfully!');
                return response?.data;
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async editVendorCategory({dispatch, commit}, data) {
            try {
                commit('setLoading', true);
                await api.editVendorCategory(data);
                dispatch('getVendorCategories', {
                    paginate: true
                });
                commit('hasErrors', false)
                ElMessage.success('Information updated successfully.');
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async deleteVendorCategory({dispatch}, data) {
            try {
                await api.deleteVendorCategory(data);
                dispatch('getVendorCategories', {
                    paginate: true
                })
                ElMessage.success("Vendor category removed successfully.")
            } catch (e) {
                if (e.response.status === 422) {
                    ElMessage.error(e.response.data.message)
                } else {
                    ElMessage.error('Error deleting vendor category');
                }
            }
        }
    }
}
